import { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { uiAction, spotsAction } from "../store/store-actions";
import { useHttp } from "../hooks/use-http";
import { POPULAR_CITIES } from "../config";

const PopularCities = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const sendRequest = useHttp();
  const curLocGeoCords = useSelector(
    (state) => state.uiStates.curLocGeoCords.lat_lng
  );

  const applyData = (data) => {
    dispatch(spotsAction.setSpots(data.spots));
    dispatch(uiAction.setMoreResultsCount(Number(data.pageCount)));
    history.push("/parkingSpots");
  };

  const popularCitiesParkingSpots = (city) => {
    dispatch(uiAction.setSearchedLocGeoCords(city.lat_lng));
    dispatch(uiAction.setPostCodeSearched(false));
    dispatch(uiAction.setSearchText(city.opt_val));
    sendRequest(
      {
        url: `getParkingSpots.json`,
        method: "POST",
        data: {
          current_lat_lng: curLocGeoCords,
          searched_lat_lng: city.lat_lng,
          searchText: city.opt_val,
          postCodeSearched: false,
        },
      },
      applyData
    );
  };

  return (
    <Fragment>
      <ul>
        {POPULAR_CITIES.map((city, idx) => (
          <li key={idx}>
            <p
              className="text-sm leading-loose hover:text-primary cursor-pointer"
              onClick={popularCitiesParkingSpots.bind(null, city)}
            >
              {city.name}
            </p>
          </li>
        ))}
      </ul>
    </Fragment>
  );
};

export default PopularCities;
